import { Box, CircularProgress } from '@mui/material';
import { isEqual } from 'lodash';
import React from 'react';
import { createPortal } from 'react-dom';

import { IStoryContentsFrameProps, StoryContentsFrame } from '../../../utils/StoryContentsFrame/story';

import { styles } from './Content.styles';
import { useModal } from '../StoryView/contexts/ModalContext';

export type IContentProps = IStoryContentsFrameProps & {
  isLoading: boolean;
  isSettingsLoading: boolean;
  isLoadingProposals: boolean;
};

function ContentInternal(props: IContentProps) {
  const { isLoading, isSettingsLoading, isLoadingProposals, ...restProps } = props;
  const { currentModal } = useModal();

  if (isLoading || isSettingsLoading || isLoadingProposals) {
    return (
      <Box sx={styles.centered}>
        <CircularProgress size={48} />
      </Box>
    );
  }

  return (
    <Box component="main" sx={styles.root} id="mainContent">
      <StoryContentsFrame {...restProps} />
      {currentModal && createPortal(currentModal, document.body)}
    </Box>
  );
}

export const Content = React.memo(ContentInternal, (prevProps: IContentProps, nextProps: IContentProps) => {
  return (
    isEqual(prevProps.isLoading, nextProps.isLoading) &&
    isEqual(prevProps.isSettingsLoading, nextProps.isSettingsLoading) &&
    isEqual(prevProps.isLoadingProposals, nextProps.isLoadingProposals) &&
    isEqual(prevProps.isReadOnly, nextProps.isReadOnly) &&
    isEqual(prevProps.storyContents, nextProps.storyContents) &&
    isEqual(prevProps.storyCustomColors, nextProps.storyCustomColors)
  );
});

Content.displayName = 'Content';
